import { render, staticRenderFns } from "./rpterstdapprove.vue?vue&type=template&id=52953cde&"
import script from "./rpterstdapprove.vue?vue&type=script&lang=js&"
export * from "./rpterstdapprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports